import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { PageDefault } from '../PageDefault';
import { AppConfig } from './../../app/app.config';
import { NormalReportService } from '../../services/normalreport.service';
import { StorageService } from '../../providers/storage.service';
import { LotteryModel } from '../../models/lottery.model';
import { NewsService } from './../../services/news.service';

@Component({
    selector: 'normal-search',
    templateUrl: 'normalsearch.html',
    providers: [
        NewsService,
        NormalReportService
    ]
})
export class NormalSearch {
    issueNo = "";
    state = "";
    start = PageDefault.endNowDate();
    end = PageDefault.endDate();
    lotteryCode = "_ALL";
    lotteryCodes = [];
    PageIndex = 1;
    type='0';
    subUserName:string='';
    subUserNames=[];
    tracks = {};
    username = this.config.getCurrentUser().UserName;
    listFlag:boolean=false;
    items=[];
    constructor(
        private viewCtrl: ViewController,
        private navpar: NavParams, 
        private normalreport: NormalReportService, 
        private newsService: NewsService,
        private config:AppConfig,
        private storage: StorageService) {
        this.getAllLotterys();
        // this.getSubUserNames();
        this.issueNo = navpar.data.issueNo != undefined ? navpar.data.issueNo : "";
        this.state = navpar.data.state != undefined ? navpar.data.state : "";
        this.start = navpar.data.startDate != undefined ? navpar.data.startDate : PageDefault.endNowDate();
        this.end = navpar.data.endDate != undefined ? navpar.data.endDate : PageDefault.endDate();
        this.lotteryCode = navpar.data.lotteryCode != undefined ? navpar.data.lotteryCode : "_ALL";    
        this.subUserName=navpar.data.subUserName!= undefined?navpar.data.subUserName:"";         
        this.PageIndex = 1;
        if( navpar.data.Type=='1' && navpar.data.Type){
            this.type='1';
            this.getSubUserNames();
        }else{
            this.type='0';
        }
    }


    //查询条件
    //TQQ 2016-12-30
    applyFilters() {
        this.tracks["issueNo"] = this.issueNo;
        this.tracks["state"] = this.state;
        this.tracks["startDate"] = this.start;
        this.tracks["endDate"] = this.end;
        this.tracks["lotteryCode"] = this.lotteryCode;
        this.tracks["PageIndex"] = 1;
        this.tracks["Type"]=this.type;
        this.tracks["subUserName"] = this.subUserName;     
        this.dismiss(this.tracks);
    }


    //获取当前用户的下级列表
    //TQQ 2017-06-15
    getSubUserNames() {
        this.newsService.getSubUserNames().then(data => {
            if (!data || data.length < 1) {
                return;
            }
            this.subUserNames=[{ label: "请选择", value: "" }];
            data.forEach(u => {
                this.subUserNames.push({ label: u, value: u });
            });
            this.subUserName=this.subUserName?this.subUserName:this.subUserNames[0].value;
            // this.subUserName=this.subUserName?this.subUserName:"";     
        });
    } 
  
    //实时输入搜索功能
    //chen 2017-08-17
    getItems(str) {
        // this.getSubUserNames();
        this.items=this.subUserNames;
        this.listFlag=true;
        var val = str;
        if (val && val!= '') {
            this.items = this.subUserNames.filter((item) => {
                return (item.value.toLowerCase().indexOf(val.toLowerCase()) > -1);
            })
        }
    }

    //选择下级用户
    //chen 2017-08-17
    // getName(obj){
    //     this.subUserName=obj.value;
    //     this.listFlag=false;
    // }

    //获取所有彩种
    getAllLotterys() {
        var lotterys = this.storage.read<LotteryModel[]>("lotterys");
        if (lotterys != null) {
            this.lotteryCodes = lotterys;
        } else {
            this.normalreport.getAllLotterys().then(s => {
                this.lotteryCodes = s;
            });
        }
        this.lotteryCodes.splice(0,0,{LotteryCode:"_ALL",LotteryName:"全部"});
    }

    //判断是个人或团队
    //chen 2017-08-16
    perTeam(){
        if(this.type=='1'){
            this.getSubUserNames();
        }
    }

    //搜索框获取焦点事件
    //chen 2017-08-17
    // searchFocus(){
    //     this.listFlag=true;
    //     this.items=this.subUserNames;
    // }

    // searchBlur(){
    //     this.listFlag=false;
    // }
    //关闭
    //TQQ 2016-12-30
    dismiss(data?: any) {
        this.viewCtrl.dismiss(data);
    }



}


// WEBPACK FOOTER //
// ./src/pages/normalreport/normalsearch.ts